import Immutable from 'immutable'
import moment from 'moment'

import PartnerRelationship from './PartnerRelationship'

export const PartnerRecord = Immutable.Record({
  attributes: Immutable.Set(),
  authHash: '',
  clientId: null,
  dateAdded: null,
  dateUpdated: null,
  id: null,
  name: null,
  number: null,
  relationships: Immutable.Set(),
  url: null,
}, 'Partner')

export default function createPartner({
  attributes = [],
  dateAdded,
  dateUpdated,
  relationships = [],
  ...data
} = {}) {
  return new PartnerRecord({
    attributes: Immutable.Set(attributes),
    dateAdded: dateAdded ? moment(dateAdded) : null,
    dateUpdated: dateUpdated ? moment(dateUpdated) : null,
    relationships: Immutable.Set(relationships
      .filter(r => r)
      .map(r => new PartnerRelationship(r)),
    ),
    ...data,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Partner.js